import React from 'react';
import { Button } from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
const DayButton = ({
  Select,
  day,
  selectedDay,
  // duplicateItems,
}) => {
  // const isDayDuplicate = duplicateItems?.includes(
  //   day?.Text
  // );

  return (
    <React.Fragment>
      <Button
        variant="contained"
        // color={
        //   Select || selectedDay?.Id === day?.Id
        //     ? "colorPrimer"
        //     : "colorSecondary"
        // }
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1em',
          minWidth: '10.4em',
          minHeight: '95px',
          backgroundColor:
            selectedDay?.Id === day?.Id
              ? `${themeColors.ColorPrimary} !important`
              : `${themeColors.ColorSecondary} !important`,
          color:
            selectedDay?.Id === day?.Id
              ? `${themeColors.ColorSecondary} !important`
              : `${themeColors.ColorPrimary} !important`,
        }}
        fullWidth
      >
        <p>{ArabicToPersian(day?.dayName)}</p>
        <p>{day?.Text}</p>
        <p>{day?.timeDuration}</p>
      </Button>
    </React.Fragment>
  );
};

export default DayButton;
